import { WalletIcon } from "@src/assets";
import { shortAddress } from "@src/utils";

export const ExternalAddressCard = ({ address }) => {
  return (
    <div className={`bg-card_bg rounded-xl`}>
      <div
        className={`flex text-xs justify-between text-text_primary rounded-xl px-4 py-3`}
      >
        <p>Deliver to:</p>
        <div className="flex gap-2">
          <p className="font-medium text-theme_color">
            {shortAddress(address)}
          </p>
          <WalletIcon className="w-4 h-4 !fill-text_primary/60" />
        </div>
      </div>
    </div>
  );
};
